export default __webpack_public_path__ + "static/media/bg4.35cfd30a.jpg";